'use client'

import { useState, useEffect } from 'react'
import ColorSelector from './ColorSelector'
import AddToCartButton from './AddToCartButton'
import type { Product, Color } from '@/lib/types'

interface ProductPurchaseSectionProps {
  product: Product
  colors: Color[]
  onColorChange?: (color: Color | null) => void
}

export default function ProductPurchaseSection({
  product,
  colors,
  onColorChange,
}: ProductPurchaseSectionProps) {
  const [selectedColorId, setSelectedColorId] = useState<string>(colors[0]?.id || '')

  // Notify parent of initial color selection
  useEffect(() => {
    if (onColorChange && colors[0]) {
      onColorChange(colors[0])
    }
  }, []) // Run only on mount

  const handleColorSelect = (colorId: string) => {
    setSelectedColorId(colorId)
    if (onColorChange) {
      const selectedColor = colors.find((c) => c.id === colorId) || null
      onColorChange(selectedColor)
    }
  }

  return (
    <div className="bg-white rounded-3xl shadow-soft p-6 space-y-6">
      <ColorSelector
        colors={colors}
        product={product}
        selectedColorId={selectedColorId}
        onColorSelect={handleColorSelect}
      />
      <AddToCartButton product={product} colors={colors} selectedColorId={selectedColorId} />
    </div>
  )
}
